module.exports = __webpack_public_path__ + "media/images/icons/info-10b59de15e75c55bc3826e35eee70be9.svg";